/*!
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { APP_VERSION } from './app-version';
import { WhatsNewService } from './whats-new.service';

/** Bottom-of-sidebar version label; click opens the changelog dialog. */
@Component({
  selector: 'app-sidebar-version',
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatTooltipModule, TranslatePipe],
  encapsulation: ViewEncapsulation.None,
  template: `
    <button class="aca-version" (click)="openChangelog()" [matTooltip]="'DMS.CHANGELOG.TOOLTIP' | translate">
      <mat-icon class="aca-version__icon">info</mat-icon>
      <span class="aca-version__label">{{ 'DMS.CHANGELOG.VERSION' | translate: { p0: version } }}</span>
      <span class="aca-version__new">{{ 'DMS.CHANGELOG.TITLE' | translate }}</span>
    </button>
  `
})
export class SidebarVersionComponent {
  private readonly whatsNew = inject(WhatsNewService);
  readonly version = APP_VERSION;

  openChangelog(): void {
    this.whatsNew.open();
  }
}
